<div class="content psf-layer">
  <h1 class="psf-fade-in-animation-300">Settings</h1>
  @if((connectedUser | async)?.roles?.includes(Roles.ADMIN)){
    <tds-segmented-control [(selectedIndex)]="selectedTab">
      <button tds-segmented-control-option>PMO</button>
      <button tds-segmented-control-option>Analyst</button>
      <button tds-segmented-control-option>Region Manager</button>
    </tds-segmented-control>

    @if (selectedTab() === 0) {
      <div tds-tile variant="auto" class="psf-layer">
        <app-manage-pmo></app-manage-pmo>
      </div>
    }

    @if (selectedTab() === 1) {
      <div tds-tile variant="auto" class="psf-layer">
        <app-manage-analyst></app-manage-analyst>
      </div>
    }

    @if (selectedTab() === 2) {
      <div tds-tile variant="auto" class="psf-layer">
        <app-manage-region-manager></app-manage-region-manager>
      </div>
    }
  }
</div>
